import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { Alert, Button, Card, CardContent, Container, Stack } from '../design-system';
import { useAuth } from '../context/AuthContext';

export default function ProfilePage() {
  const { user, updateProfile } = useAuth();
  const [fullName, setFullName] = useState(user?.nombre || '');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      await updateProfile({ fullName: fullName.trim() });
      setMessage('Perfil actualizado.');
    } catch (updateError) { setError(updateError.message || 'No se pudo actualizar el perfil.'); }
    finally { setSaving(false); }
  };
  return <Container className="wp-page" maxWidth="md" sx={{ py: 5 }}>
    <Typography component="h1" variant="h4" fontWeight={800} gutterBottom>Mi perfil</Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>Gestiona tus datos personales. Tus permisos dependen de la licencia activa.</Typography>
    <Card><CardContent><Stack component="form" onSubmit={submit} spacing={2}>
      {message && <Alert severity="success">{message}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
      <TextField label="Email" value={user?.email || ''} fullWidth disabled helperText="El email se gestiona a través de Supabase Auth." />
      <TextField label="Nombre completo" value={fullName} onChange={(event) => setFullName(event.target.value)} required fullWidth />
      <Box><Button type="submit" variant="contained" disabled={saving}>{saving ? 'Guardando...' : 'Guardar cambios'}</Button></Box>
    </Stack></CardContent></Card>
  </Container>;
}
